import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, ListaCep } from './types';

export const INITIAL_STATE: ListaCep = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ListaCep {
	return produce(state, draft => {
		switch (action.type) {
			case Types.LISTA_CEP: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.LISTA_CEP_SUCCESS: {
				draft.data = action.payload;
				draft.status = 200;
				break;
			}

			case Types.LISTA_CEP_FAILURE: {
				draft.status = 400;
				break;
			}
			case Types.LISTA_CEP_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
